import {useEffect, useLayoutEffect, useState} from "react";
import {CreateEmployeeContractor} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi";
import {Contractor} from "../../../../../models/Contractor";
import {toast} from "react-toastify";
import {GetAllServiceType} from "../../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {getPhotoPicker} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg, isEmailFormat, isPhoneFormat, isValidLengthDocumentId} from '../../../../../Apis/functions';
import routes from "../../../../../Routes/routes";
import {STEPS_CONTRACTOR_CREATE, STEPS_CONTRACTOR_CREATE_NO_DETAILS, TABS_CONTRACTORS} from "../../Model/Models";
import { EXTRA_DATA } from "../../../Company/Employees/Model/Models";
import { useSelector } from "react-redux";
import { GetUserRestriction } from "../../../../../reduxToolkit/restrictions/RestrictionApi";
import HandleChange from "../../../../../Helpers/HandleChange";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const EmployeeFlowContractorCreateApp =({
       t,
       dispatch,
       navigate,
       workShiftsList,
       customizedList,
       setEmptyFields,
       setIsValidEmail,
       isValidPassword, 
       setIsValidPassword,
       setIsValidPhoneNumber,
       isValidDob,
       photoPicker,
       setPhotoPicker,
       permission,
       setWorkShiftsList,
       setCustomizedList,
       setSecretModal,
       setSecretKey,
       setGeneratedPassword,
       passwordGenerator,
       setSteps,
       setIsValidDocumentId,
       isValidDocumentId,
       setExtraData,
       headersList, 
       extraData,
       extraDataEnabled,
       setExtraDataEnabled
    })=>{

    const [getAllServiceType, setGetAllServiceType] = useState([])
    const [user, setUser] = useState({...Contractor});

    useEffect(()=>{
        dispatch(GetAllServiceType()).then(({payload:{data:{data}}})=>{
            setGetAllServiceType(data)
        });
         dispatch(GetUserRestriction()).then(
                    ({
                        payload: {
                            data: { data, success },
                        },
                    }) => {
                        if (success === true) {
                            setExtraDataEnabled(data?.extraDataContractor);
                        }
                    },
                );
    },[dispatch])

     const  STEP_EMPLOYEE_CREATE = (extraDataEnabled) => {
        if (extraDataEnabled){
            return [t("company_details"), t("manager_details"), t('other_details'), t("add_photo"), t("access_right"), t("summary")];
        }
        return [t("company_details"), t("manager_details"), t("add_photo"), t("access_right"), t("summary")];
    }

    useLayoutEffect(() => {
        setSteps([...STEP_EMPLOYEE_CREATE(extraDataEnabled)]);
    }, [extraDataEnabled, permission, t]);

    //  reset function    
    const resetForm = (step) => {
        if(step === STEPS_CONTRACTOR_CREATE.COMPANY_DETAILS){
            setUser({...user.clearCompanyDetails()});
        }
        if(step === STEPS_CONTRACTOR_CREATE.MANAGER_DETAILS){
            setUser({...user.clearManagerDetails()});
        }
        if(step === STEPS_CONTRACTOR_CREATE.ACCESS_RIGHT){
            setWorkShiftsList([]);
            setCustomizedList([]);
        }
        setEmptyFields(false);
    };

    // Form handeler Function
    const FormHandler = () => {
        const emailOk = isEmailFormat(user.email);
        const phoneOk = isPhoneFormat(user.phoneNumber);
        const docummentIdOk =  isValidLengthDocumentId(user.documentId)

        if (!user.isValid() ||
            !isValidDob ||
            !isValidPassword ||
            !phoneOk ||
            !emailOk ||
            !isValidDocumentId
        ) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true)
            setIsValidEmail(emailOk);
            setIsValidPhoneNumber(phoneOk);
            setIsValidDocumentId(docummentIdOk);
        } else {
            setEmptyFields(false);
            createContractor();
        }
    };

    const createContractor = () => {
        const customs = customizedList
            .filter((element) => element.added === true && element.new === true)
            .map(({ zoneId, zoneName, dayId, from, to }) => ({
                zoneId: zoneId,
                zoneName: zoneName,
                dayId: dayId,
                from: from,
                to: to,
            }));

        let imageFile = getPhotoPicker(photoPicker);
        const addPw = user?.password?.trim() !== '' && user?.password !== null;
        const password = addPw ? user.password : passwordGenerator();
        const requestData = {
            data: {
                ...user.toCreateUpdate(password, extraData),
                workShifts: workShiftsList,
                customs: customs,
            },
            file: imageFile,
        };

        dispatch(CreateEmployeeContractor(requestData)).then(({payload:{data:{success, code, data}}}) => {
            if (success) {
                setSecretModal(true);
                setSecretKey(data?.secret);
                setGeneratedPassword(addPw ? null : password );
                toast.success(t('has_been_created_successfully'));
                setEmptyFields(false);
            }else{
                errorMsg(code)
            }
        });
    }

    const handleValidateSteps = (step, isWithoutDetails = false) => {
    const STEPS = isWithoutDetails
        ? STEPS_CONTRACTOR_CREATE_NO_DETAILS
        : STEPS_CONTRACTOR_CREATE;

    switch (step) {
        case STEPS.COMPANY_DETAILS: {
            if (!user.isValidCompanyDetails()) {
                setEmptyFields(true);
                return false;
            }
            setEmptyFields(false);
            return true;
        }

        case STEPS.MANAGER_DETAILS: {
            const emailOk = isEmailFormat(user.email);
            const phoneOk = isPhoneFormat(user.phoneNumber);
            const docummentIdOk = isValidLengthDocumentId(user.documentId);

            if (
                !user.isValidManagerDetails() ||
                !isValidDob ||
                !phoneOk ||
                !emailOk ||
                !isValidPassword ||
                !isValidDocumentId
            ) {
                setIsValidEmail(emailOk);
                setIsValidPhoneNumber(phoneOk);
                setIsValidDocumentId(docummentIdOk);
                setEmptyFields(true);
                return false;
            }

            setEmptyFields(false);
            return true;
        }

        default:
            return true;
    }
};

    const handleOnBack = () => {
        navigate(routes.contractor.list, {
            state: {currentTab:TABS_CONTRACTORS.CONTRACTORS.INDEX}
        });
    }

     /**
     * This function handles changes in the form fields for extra data. It updates the 'extraData' state by spreading the previous data
     * and updating the specific field (identified by 'name') with the new value from the form input.
     */

  const { handleChange } = HandleChange({
    model: extraData,
    setModel: setExtraData,
 });

    /**
         * handle for reset extra data
         */
        const handleClearExtraData = () => {
            setExtraData({...EXTRA_DATA});
        }

    return {
        user,
        setUser,
        FormHandler,
        resetForm,
        getAllServiceType,
        handleValidateSteps,
        handleOnBack,
        handleChange,
        handleClearExtraData,
    };
}